<div class="flyout-headline-component">
  <div class="flyout-headline-row main-row">
    <div class="flyout-header-icon">
      @if (!img && !!icon) {
        <mat-icon>{{ icon }}</mat-icon>
      }
      @if (!!img) {
        <img class="img-profile" [src]="img" />
      }
    </div>
    <div class="flyout-header-texts">
      <div class="flyout-header-text-column">
        <div class="header-top-row">
          <app-flyout-star-scoring class="contact-stars" [commitment]="commitment" [flyoutData]="flyoutOpeningData"></app-flyout-star-scoring>
          <div class="header-close-icon">
            <mat-icon class="close-icon" (click)="closeFlyout()">close</mat-icon>
          </div>
        </div>
        <div class="headline-content-row">
          <div class="headline-left-column">
            @if (isSession) {
              <div class="contact-title">Session: {{ firstVisitTimestampNumber ? (firstVisitTimestampNumber / 1000 | formatDate) : "N/A" }}</div>
            }
            @if (!isSession) {
              <div
                class="contact-title"
                [class.clickable]="flyoutOpeningData?.identifier && flyoutOpeningData.type !== FlyoutDataType.Contact"
                [matTooltip]="title | removeHtml"
                [matTooltipDisabled]="isMobile"
                (click)="clickOnTitle()"
                [innerHTML]="title"></div>
            }
            @if (subTitle) {
              <div
                [class.clickable]="flyoutOpeningData?.identifier && flyoutOpeningData.type !== FlyoutDataType.Contact"
                class="contact-subtitle"
                (click)="clickOnSubtitle()"
                [matTooltip]="subTitle | removeHtml"
                [matTooltipDisabled]="isMobile"
                [innerHTML]="subTitle"></div>
            }
            @if (!loadingData) {
              <app-flyout-time-overview
                class="flyout-time-overview"
                [flyoutDataType]="flyoutOpeningData?.type"
                [firstVisit]="firstVisit"
                [secondsOnSite]="secondsOnSite"
                [latestVisit]="latestVisit"></app-flyout-time-overview>
            }
          </div>
          @if (interestProfileStatistics && interestProfileStatistics.length > 0) {
            <div class="headline-right-column">
              <app-flyout-interest-profile-chart [dataArray]="interestProfileStatistics"></app-flyout-interest-profile-chart>
            </div>
          }
        </div>
        <!--<div *ngIf="countryCode" class="country-box">
        <div class="country-flag">
          <img src="/assets/img/flags_iso_svg/{{countryCode | lowercase}}.svg">
        </div>
        <div class="country-name">{{('countries.' + countryCode) | lowercase | translate}}</div>
      </div>-->
      </div>
    </div>
  </div>
</div>
